// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__EuIIN","wrapper":"Footer_wrapper__q9dYD","share":"Footer_share__9sIeK","claimNftButton":"Footer_claimNftButton__gNqEt"};